import Vue from 'vue';
import VueRouter from 'vue-router';
import News from '@/views/News.vue';
import LoteryDashboard from '../views/LoteryDashboard/LoteryDashboard.view.vue';
import HabitsDashboard from '../views/HabitsDashboard/HabitsDashboard.view.vue';
import LandingPage from '../views/LandingPage/LandingPage.view.vue';
import SignIn from '../views/SignIn/SignIn.vue';
import TrialWrapper from '../views/TrialChat/TrialWrapper.vue';
import SupportUs from '../views/SupportUs.vue';
import Discord from '../views/Discord.vue';
import EmbedView from '../views/EmbedView/EmbedView.vue';
import QRCodeGenerator from '../views/QRCodeGenerator.vue';
import QRCodeGeneratorForAll from '../views/QRCodeGeneratorForAll.vue';
import SuccessPage from '../views/SuccessPage.vue';
import Gamefy from '../views/GamefyPage/Gamefy.view.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/welcome',
    component: LandingPage,
    name: 'landingpage',
    meta: {
      showMenu: false,
    },
  },
  {
    path: '/',
    redirect: '/HabitsDashboard',
  },
  {
    path: '/lotery',
    name: 'Lotery',
    component: LoteryDashboard,
    meta: {
      requiresAuth: true,
      showMenu: true,
    },
  },
  {
    path: '/HabitsDashboard',
    name: 'HabitsDashboard',
    component: HabitsDashboard,
    meta: {
      requiresAuth: true,
      showMenu: true,
    },
  },
  {
    path: '/intro',
    name: 'Intro',
    component: TrialWrapper,
    meta: {
      requiresAuth: true,
      showMenu: false,
    },
  },
  {
    path: '/support-us',
    name: 'SupportUs',
    component: SupportUs,
    meta: {
      requiresAuth: true,
      showMenu: true,
    },
  },
  {
    path: '/discord',
    name: 'Discord',
    component: Discord,
    meta: {
      requiresAuth: true,
      showMenu: true,
    },
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      requiresAuth: true,
      showMenu: true,
    },
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn,
    meta: {
      showMenu: false,
    },
  },
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/embed',
    name: 'EmbedView',
    component: EmbedView,
    meta: {
      requiresAuth: false,
      showMenu: false,
    },
  },
  {
    path: '/qrcode',
    name: 'QRCodeGenerator',
    component: QRCodeGenerator,
    meta: {
      requiresAuth: false,
      showMenu: false,
    },
  },
  {
    path: '/success',
    name: 'SuccessPage',
    component: SuccessPage,
    meta: {
      requiresAuth: false,
      showMenu: false,
    },
  },
  {
    path: '/short',
    name: 'short',
    meta: {
      requiresAuth: false,
      showMenu: false,
    },
    async beforeEnter(to, from, next) {
      next({ path: '/success', query: { id: to.query.id } });
    },
  },
  {
    path: '/qrcode-generator',
    name: 'qrCodeGenerator',
    component: QRCodeGeneratorForAll,
    meta: {
      requiresAuth: true,
      showMenu: true,
    },
  },
  {
    path: '/gamefy',
    name: 'Gamefy',
    component: Gamefy,
    meta: {
      requiresAuth: true,
      showMenu: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeResolve(async (to, from, next) => {
  const isOnStandalone = true;
  // const isOnStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isLocal = window.location.origin.includes('localhost');
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const withoutAccessQuard = to.path === '/short' || to.path === '/success';
  if (withoutAccessQuard) {
    return next();
  }
  const showWelcomePage = !isOnStandalone && !isLocal;
  // let isNotLoginIn = !localStorage.getItem('user');
  // if (isNotLoginIn) isNotLoginIn = !await firebase.getCurrentUser();
  const userExist = localStorage.getItem('user');

  if (showWelcomePage) {
    if (to.path !== '/welcome') {
      next({ path: '/welcome' });
    } else {
      next();
    }
  } else if (requiresAuth && !userExist) {
    next('signin');
  } else if (to.path === '/signin' && userExist) {
    next({ path: '/' });
  }
  return next();
});

export default router;
